var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonstersGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "333px",
    height: "247px",
    viewBox: "0 0 333 247",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.639843147 0.655 132.8588 0.655 132.8588 132.7187 0.639843147 132.7187"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.639843147 0.655 132.8588 0.655 132.8588 132.7187 0.639843147 132.7187"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0.1475 0.655 257.7135 0.655 257.7135 246.2012 0.1475 246.2012"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "0.1475 0.655 257.7135 0.655 257.7135 246.2012 0.1475 246.2012"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "0.6823 0.655 258.2483 0.655 258.2483 246.2009 0.6823 246.2009"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-11",
    points: "0.6823 0.655 258.2483 0.655 258.2483 246.2009 0.6823 246.2009"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-13",
    points: "0.175691172 0.655 132.394 0.655 132.394 132.7187 0.175691172 132.7187"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-15",
    points: "0.175691172 0.655 132.394 0.655 132.394 132.7187 0.175691172 132.7187"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platforma_ALL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ALL---2---Dashboard",
    transform: "translate(-151.000000, -3841.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(151.000000, 3841.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-60",
    transform: "translate(266.500000, 66.500000) scale(-1, 1) translate(-266.500000, -66.500000) translate(200.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0758,132.7187 L25.6118,132.7187 L132.8588,88.9147 L65.0438,-22.1803 L43.5088,-22.1803 C43.5088,-22.1803 -13.7372,29.3927 4.0758,132.7187",
    id: "Fill-58",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-63",
    transform: "translate(266.500000, 66.500000) scale(-1, 1) translate(-266.500000, -66.500000) translate(200.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0758,132.7187 L25.6118,132.7187 L132.8588,88.9147 L65.0438,-22.1803 L43.5088,-22.1803 C43.5088,-22.1803 -13.7372,29.3927 4.0758,132.7187 Z",
    id: "Stroke-61",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-66",
    transform: "translate(151.000000, 123.500000) scale(-1, 1) translate(-151.000000, -123.500000) translate(22.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7135,99.0722 C257.7135,26.0062 210.0155,-34.6098 147.4965,-46.0898 L147.4965,-48.0568 L125.9615,-48.0568 C92.9135,-48.0568 62.7075,-34.4698 39.5795,-12.0248 L125.9615,95.3812 L128.9305,99.0722 L0.1475,142.8752 C16.8425,202.7402 66.8575,246.2012 125.9615,246.2012 L147.4965,246.2012 L147.4965,244.2342 C210.0155,232.7542 257.7135,172.1382 257.7135,99.0722",
    id: "Fill-64",
    fill: "#FFF6E7",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-69",
    transform: "translate(151.000000, 123.500000) scale(-1, 1) translate(-151.000000, -123.500000) translate(22.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7135,99.0722 C257.7135,26.0062 210.0155,-34.6098 147.4965,-46.0898 L147.4965,-48.0568 L125.9615,-48.0568 C92.9135,-48.0568 62.7075,-34.4698 39.5795,-12.0248 L125.9615,95.3812 L128.9305,99.0722 L0.1475,142.8752 C16.8425,202.7402 66.8575,246.2012 125.9615,246.2012 L147.4965,246.2012 L147.4965,244.2342 C210.0155,232.7542 257.7135,172.1382 257.7135,99.0722 Z",
    id: "Stroke-67",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-72",
    transform: "translate(129.500000, 123.500000) scale(-1, 1) translate(-129.500000, -123.500000) "
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6823,142.8749 C17.3783,202.7399 67.3923,246.2009 126.4963,246.2009 C199.2613,246.2009 258.2483,180.3289 258.2483,99.0719 C258.2483,17.8149 199.2613,-48.0571 126.4963,-48.0571 C93.4493,-48.0571 63.2443,-34.4701 40.1153,-12.0241 L129.4653,99.0719 L0.6823,142.8749 Z",
    id: "Fill-70",
    fill: "#FFF6E7",
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-75",
    transform: "translate(129.500000, 123.500000) scale(-1, 1) translate(-129.500000, -123.500000) "
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6823,142.8749 C17.3783,202.7399 67.3923,246.2009 126.4963,246.2009 C199.2613,246.2009 258.2483,180.3289 258.2483,99.0719 C258.2483,17.8149 199.2613,-48.0571 126.4963,-48.0571 C93.4493,-48.0571 63.2443,-34.4701 40.1153,-12.0241 L129.4653,99.0719 L0.6823,142.8749 Z",
    id: "Stroke-73",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    mask: "url(#mask-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-78",
    transform: "translate(244.500000, 66.500000) scale(-1, 1) translate(-244.500000, -66.500000) translate(178.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.612,132.7187 L132.394,88.9147 L43.044,-22.1803 C43.044,-22.1803 -14.202,29.3927 3.612,132.7187",
    id: "Fill-76",
    fill: "#FFFFFF",
    mask: "url(#mask-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-81",
    transform: "translate(244.500000, 66.500000) scale(-1, 1) translate(-244.500000, -66.500000) translate(178.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.612,132.7187 L132.394,88.9147 L43.044,-22.1803 C43.044,-22.1803 -14.202,29.3927 3.612,132.7187 Z",
    id: "Stroke-79",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    mask: "url(#mask-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-85",
    transform: "translate(140.500000, 99.000000) scale(-1, 1) translate(-140.500000, -99.000000) translate(129.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.9303,
    y1: 1.0722,
    x2: 22.4653,
    y2: 1.0722,
    id: "Fill-82",
    fill: "#FAEFE8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.9303,
    y1: 1.0722,
    x2: 22.4653,
    y2: 1.0722,
    id: "Stroke-84",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-89",
    transform: "translate(269.000000, 143.000000) scale(-1, 1) translate(-269.000000, -143.000000) translate(258.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 21.6823,
    y1: 0.8749,
    x2: 0.9083,
    y2: 0.8749,
    id: "Fill-86",
    fill: "#FAEFE8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.6823,
    y1: 0.8749,
    x2: 0.9083,
    y2: 0.8749,
    id: "Stroke-88",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonstersGraph);
export default __webpack_public_path__ + "static/media/monstersGraph.8276a75bf7d31c3f81a3008abe38677a.svg";
export { ForwardRef as ReactComponent };